import { Component } from '@angular/core';

@Component({
    selector: 'app-unsubscribed',
    templateUrl: './unsubscribed.component.html',
    styleUrl: './unsubscribed.component.scss',
    standalone: false
})
export class UnsubscribedComponent {

}
